import React, { useState, useEffect } from 'react';
import SessionManager from '../../routes/SessionManager';
import SitesHawkEye from './SitesHawkEye';
import Toastr from 'toastr';
import Loading from '../Loading';
import CommonUtils from '../../util/CommonUtils';
import API from '../../service/SiteKickAPIService';

const DashboardMapView = () => {

    let sessionManager = new SessionManager();
    let userObj = sessionManager.readCookie('user');

    userObj.default_dashboard = 'Map View';
    const [user, setUser] = useState(userObj);
    const [site_selected, setSiteSelected] = useState(null);
    const [zones, setZones] = useState([]);
    if (!userObj["zone_prefs_for_sites"]) {
        for (var index = 0; index < userObj.user_sites.length; index++) {
            var user_site = userObj.user_sites[index];
            userObj["zone_prefs_for_sites"] = { ...userObj["zone_prefs_for_sites"], [user_site]: userObj.zone_prefs }
        }
    }

    useEffect(() => {
        if (user.site_locations) {
            let siteDefault = user.site_selected;
            if (!siteDefault)
                siteDefault = getDefaultSite(user.site_locations);
            setSiteSelected(siteDefault);
        } else {
            fetchSiteLocations();
        }
    }, []);

    useEffect(() => {
        if (site_selected !== null) {
            fetchSiteLocationZones();
        }
    }, [site_selected]);

    let fetchSiteLocations = () => {
        var data = {
            customer_id: user.customer_id,
            site_id: user.user_sites,
            user_login: user.user_login,
            user_token: user.user_token
        }
        CommonUtils.ajax(
            {
                url: API.SITE.BASE,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    let site_locations = res.data ? res.data.filter(x => x.site_state.trim().toUpperCase() !== 'INACTIVE') : [];
                    let loc = 'site_name';
                    site_locations = site_locations.sort((a, b) => a[loc] > b[loc] ? 1 : a[loc] < b[loc] ? -1 : 0);

                    let _user = JSON.parse(JSON.stringify(user));
                    _user.site_locations = site_locations;

                    if (site_locations && site_locations.length > 0) {
                        let siteDefault = getDefaultSite(site_locations);
                        if (siteDefault) {
                            _user.site_selected = siteDefault;
                            sessionManager.storeCookie('user', _user);
                        }
                        setUser(_user);
                        setSiteSelected(_user.site_selected);
                    } else {
                        sessionManager.storeCookie('user', user);
                        Toastr.error('No Sites Found ...');
                        window.location = './message';
                    }
                }
            },
            (res) => {

            });
    }

    let fetchSiteLocationZones = () => {
        var data = {
            customer_id: site_selected.customer_id,
            site_id: site_selected.site_id,
            user_login: user.user_login,
            user_token: user.user_token
        }

        CommonUtils.ajax(
            {
                url: API.LOCATION.BASE,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {

                if (res && res.status && res.status.code === 200) {
                    let zone_prefs = user.zone_prefs_for_sites ? user.zone_prefs_for_sites[site_selected.site_id] : null;
                    var filteredZones = (res.data).filter(zone => zone.location_adminstatus === "Up");

                    if (zone_prefs && zone_prefs.length > 0) {
                        var sortedZones = filteredZones.sort((a, b) => {
                            return zone_prefs.indexOf(a.location_id) - zone_prefs.indexOf(b.location_id);
                        });
                    } else {
                        sortedZones = filteredZones;
                    }

                    //User accessible zones only.
                    let user_zones = user.user_zones;
                    if (user_zones && user_zones[site_selected.site_id]) {
                        let zonesAllowed = user_zones[site_selected.site_id];
                        if (zonesAllowed.length > 0) {
                            let sortedZonesFinal = [];
                            for (let s of sortedZones) {
                                if (zonesAllowed.includes(s.location_id)) {
                                    sortedZonesFinal.push(s);
                                }
                            }
                            sortedZones = sortedZonesFinal;
                        }
                    }

                    let sessionMgr = new SessionManager();
                    let _user = sessionMgr.readCookie('user');
                    _user.zones = sortedZones;
                    sessionMgr.storeCookie('user', _user);
                    setZones(_user.zones)
                } else {
                    let sessionMgr = new SessionManager();
                    let _user = sessionMgr.readCookie('user');
                    _user.zones = [];
                    sessionMgr.storeCookie('user', _user);
                    setZones(_user.zones)
                }
            }
        );
    }

    let getDefaultSite = (site_locations) => {
        var siteDefault = null;
        let defaultSiteId = user.site_id; //Default Site;

        if (user.site_selected)
            defaultSiteId = user.site_selected.site_id;

        if (defaultSiteId) {
            for (let s of site_locations)
                if (s.site_id + '' === defaultSiteId + '') {
                    siteDefault = s;
                    break;
                }
        }

        if (!siteDefault)
            siteDefault = site_locations[0];

        return siteDefault;
    }

    return (
        <React.Fragment>
            <div className="page-container">
                {user.site_locations !== undefined && zones !== undefined ?
                    <SitesHawkEye dropdown="true" ></SitesHawkEye>
                    : <React.Fragment>
                        <div className="p-3">
                            <Loading>Loading ...</Loading>
                        </div>
                    </React.Fragment>}
            </div>
        </React.Fragment >
    )
}

export default DashboardMapView;
